import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AcademysliderService } from 'src/app/services/academyslider.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { environment } from 'src/environments/environment';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { __values } from 'tslib';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-academies-profile-slider',
  templateUrl: './academies-profile-slider.component.html',
  styleUrls: ['./academies-profile-slider.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class AcademiesProfileSliderComponent implements OnInit {
  sliderForm: FormGroup;
  sliderImagesArray: any;
  imageSize = environment.imageSize;
  sliderImages: any = [];
  academyImage: any = [];
  uploadedFiles: any[] = [];
  public showPicError: boolean = false;
  public academypic;
  // academyData: any;
  imageProfile;
  showUploadedpic: boolean;
  sliderImage: any;
  imageData: any;
  loggedInAcademy;
  loggedInAcademyId;
  loading: boolean;
  sliderdata: any;
  errorMessage = '';
  public disabled: boolean = false;
  imageslider: any;
  public court_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },

 
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicMainBullets: 2,
    },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };
  public isAddMode: boolean;
  public sliderImagesId;
  public deletedImages: any[] = [];
  constructor(private sliderservice: AcademysliderService,
    private tokenStorage: TokenStorageService,
    private messageService: MessageService,
    private router: Router,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
    this.loggedInAcademy = this.tokenStorage.getUser();
    this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
    let academyPaymentDetails = this.loggedInAcademy.userdata.academyPaymentDetails;
    let roleName = this.loggedInAcademy.userdata.rolename;
    let currentUrl = '/';
    if (roleName == "academy") {
      if (Object.keys(academyPaymentDetails).length > 0) {
        if (academyPaymentDetails.academyPaymentStatus == 'created') {
          currentUrl = '/payment-history';
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      } else {
        currentUrl = '/payment-history';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }
    }
    this.loadSlider();
    this.sliderForm = this.fb.group({
      status: [true],
      disable: [false],
    })
  }
  loadSlider() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.sliderservice.getAcademyslderList(query).subscribe(data => {
      this.loading = false;
      this.sliderdata = data.data.items;
      if (this.sliderdata.length > 0) {
        this.isAddMode = false;
        this.sliderImagesId = this.sliderdata[0].id;
        if (this.sliderdata[0]['slider_image']) {
          this.imageslider = this.sliderdata[0]['slider_image'];
        }
      } else {
        this.isAddMode = true;
      }
    },
      err => {
        this.errorMessage = err.error.message;
      });
  }


  picUploader(event) {
    this.sliderImages = [];
    this.showPicError = false;
    let index = 0;
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.sliderImages.push({ 'file': reader.result });
          index++;
        }
      }
    }
  }

  onSubmit(mode) {
    this.sliderImagesArray = [];
    if (mode != 'delete') {
      if ((this.sliderImages.length > 0)) {
      this.sliderImages.forEach((element, index) => {
      this.sliderImagesArray.push({ 'file': element.file });
      });
      this.showPicError = false;
      } else {
      this.showPicError = true;
      return;
      }
      }
    var academyData = this.sliderForm.value;
    academyData['slider_images'] = this.sliderImagesArray;
    if (this.isAddMode) {
      academyData['academyId'] = this.loggedInAcademyId;
      academyData = JSON.stringify(academyData, null, 4)
      this.addSliderImages(academyData);
    } else {
      academyData['deleted_images'] = this.deletedImages;
      academyData = JSON.stringify(academyData, null, 4);
      this.updateSliderImages(this.sliderImagesId, academyData);
    }
  }
  updateSliderImages(sliderImagesId, academyData) {
    this.sliderservice.updateAcademySlider(sliderImagesId, academyData).subscribe(
      data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Academy Gallery image updated successfully.', life: 6000 });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate(['/academies-profile/academies-profile-slider']);
        }, 200);
        // this.sliderImagesArray = [];
        // this.sliderImages = [];
        // this.deletedImages = [];
        // this.uploadedFiles = [];
        // this.loadSlider();
      },
      err => {

      })
  }
  addSliderImages(academyData) {
    this.sliderservice.addAcademySliderImage(academyData).subscribe(
      (data) => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Added Successfully', life: 6000 });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate(['/academies-profile/academies-profile-slider']);
        }, 200);
        this.sliderImagesArray = [];
        this.sliderImages = [];
        this.deletedImages = [];
        this.uploadedFiles = [];
        this.loadSlider();
        this.uploadedFiles = [];
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add failed', life: 6000 });

      })
    );
  }

  removeImages(image: any): void {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deletedImages.push(image.slider_image_src);
        //for (let removedImage of this.teamImages) {
        this.sliderImages = this.sliderImages.filter((item) => item.slider_image_src !== image.slider_image_src);
        // }
        this.onSubmit('delete');
      },
      reject: () => {
        this.loadSlider();
      }
    });
  }
  public onIndexChange(index: number): void {
    //console.log('Swiper index: ', index);
  }

  public onSwiperEvent(event: string): void {
    //console.log('Swiper event: ', event);
  }

  public toggleKeyboardControl(): void {
    this.court_config.keyboard = !this.court_config.keyboard;
  }

  public toggleMouseWheelControl(): void {
    this.court_config.mousewheel = !this.court_config.mousewheel;
  }
}
